// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBox_wrap__MUcJK","main":"SearchBox_main__bTpLd"};